module.exports = __webpack_public_path__ + "img/logo utec.03825f55.png";